import { getOption as getSelectedOption } from './filter/selection';
import updateCategories from '../shared/filter/helpers/updateCategories';

export const getCategories = (tab, type, reducer, categories) => {
    const key = `filter_${tab}_${type}`;
    const storedActions = JSON.parse(localStorage.getItem(key));

    if (!Array.isArray(storedActions)) {
        return null;
    }

    return storedActions.reduce((acc, action) =>
        updateCategories(acc, reducer, action), categories);
};

export const setCategories = (tab, type, categories) => {
    const key = `filter_${tab}_${type}`;
    const actions = Object.keys(categories).map(categoryName => ({
        type: categoryName,
        value: getSelectedOption(categories, categoryName).value,
    }));
    localStorage.setItem(key, JSON.stringify(actions));
};




// WEBPACK FOOTER //
// ./src/js/utils/storage.js